import { Box, DialogActions } from '@mui/material';
import { MDButton } from '../MDButton';

interface IProps {
    formId: string;
    isSubmitting: boolean;
    onCancel: () => void;
    showDelete?: boolean;
    onDelete?: () => void;
}

export const ModalDialogActions = ({ formId, isSubmitting, onCancel, showDelete, onDelete }: IProps) => (
    <DialogActions
        sx={{
            display: 'flex',
            justifyContent: showDelete ? 'space-between' : 'flex-end',
            width: '100%',
            px: 2,
            pb: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
        }}
    >
        {showDelete && onDelete && (
            <MDButton color='error' variant='outlined' onClick={onDelete}>
                Delete
            </MDButton>
        )}
        <Box sx={{ display: 'flex', gap: 1 }}>
            <MDButton color='primary' variant='outlined' onClick={onCancel}>
                Cancel
            </MDButton>
            <MDButton
                color='primary'
                variant='contained'
                type='submit'
                form={formId}
                disabled={isSubmitting}
            >
                Save
            </MDButton>
        </Box>
    </DialogActions>
);
